import {connect} from 'react-redux';

import Headers from '../components/Headers';
import {login_in, login_out, login_cancel} from '../redux/actions';

export default connect(
    state=>({login : state.Login, user : state.User}),
    {login_in, login_out, login_cancel}
)(Headers)
